module.exports = __webpack_public_path__ + "img/cir4.ba9d202f.png";